export const UPDATE_SETTINGS = 'UPDATE_SETTINGS';

export const updateSettings = (data = {}) => {
  return {
    type: UPDATE_SETTINGS,
    data,
  };
};



// WEBPACK FOOTER //
// ./src/actions/settingsActions.js